import React, {useEffect, useRef} from "react";
import { Link } from "react-router-dom";
import FormatTimeStr from "../../helpers/FormatTimeStr";
import InterfaceBooking from "../../interface/InterfaceBooking";
import {useApptekster} from "../../apptekst-context";
import {SVVButtonRow, SVVButtonCustom, SVVButton} from "@komponentkassen/svv-button";
import {SVVDefinitionList, SVVDefinitionListItem} from "@komponentkassen/svv-definition-list";
import {ReminderString} from "../../helpers/SharedTypes";
import {SessionStorageKeys} from "../book/types";
import {SVVBodyText, SVVHeading} from "@komponentkassen/svv-text";

const Receipt = (props: {
  booking: InterfaceBooking;
  isRebook: boolean;
  sendReminderTo?: ReminderString
}) => {
  const t = useApptekster();
  const headingRef = useRef<HTMLHeadingElement | null>(null)
  
  useEffect(() => {
    if (headingRef?.current) {
      headingRef.current.focus()
    }
  }, [headingRef])

  useEffect(() => {
    sessionStorage.removeItem(SessionStorageKeys.SERVICE)
    sessionStorage.removeItem(SessionStorageKeys.SECTION)
    sessionStorage.removeItem(SessionStorageKeys.DATE_AND_TIME)
  }, []);
  
const getVegvesenBaseUrl = () => {
    const host = window.location.host;
    if(host.includes('localhost') || host.includes('utv.vegvesen.no')){
      return 'https://www.utv.vegvesen.no'
    }else if( host.includes('test.vegvesen.no')){
      return 'https://www.test.vegvesen.no'
    } else{
      return 'https://www.vegvesen.no'
    }
}

  const {
    booking,
    isRebook,
    sendReminderTo
  } = props;
  
  return (
    <>
      {booking?.bookingNumber && (
        <>
          <SVVHeading
            level="h2"
            ref={headingRef}
            tabIndex={-1}
          >
            {isRebook ? t("timebestilling.endret-timen") : t("timebestilling.bestilt-time")}
          </SVVHeading>
          <div className="Aligner spacing-bottom--small">
            <span className="checkmark">
              <div className="checkmark_circle"></div>
              <div className="checkmark_stem"></div>
              <div className="checkmark_kick"></div>
            </span>&nbsp;
            <span>{isRebook ? t("timebestilling.din-time-endret") : t("timebestilling.din-time-bestilt")}</span>
          </div>
          <SVVDefinitionList>
            <SVVDefinitionListItem 
              term={t("timebestilling.valgt-tjeneste")}
            >
              {booking.serviceName || "Tjeneste er ikke valgt."}
            </SVVDefinitionListItem>
            
            <SVVDefinitionListItem 
              term={t("timebestilling.trafikkstasjon-og-tidspunkt")}
            >
              {booking.sectionName || t("timebestilling.ikke-valgt")} - {booking.bookedDateTime ? FormatTimeStr(booking.bookedDateTime) : t("timebestilling.ikke-valgt")}
            </SVVDefinitionListItem>
            
            <SVVDefinitionListItem 
              term={t("timebestilling.referansenummer")}
            >
              <span data-hj-suppress>{booking.bookingNumber}</span>
            </SVVDefinitionListItem>
          </SVVDefinitionList>
          
          <div className="spacing-top--small svv-padding-bottom--px24" data-hj-suppress>
            <SVVBodyText>
              {sendReminderTo === "both" &&
                `${t("timebestilling.bekreftelse-sms-og-epost", booking.emailAddress, booking.telephoneNumber)}`
              }
              
              {sendReminderTo === "email"  &&
                  `${t("timebestilling.vi-har-sendt-deg-epost")} ${booking.emailAddress} ${t("timebestilling.som-bekrefter-timen")}`
              }
              
              {sendReminderTo === "sms" &&
                  `${t("timebestilling.vi-har-sendt-deg-sms")} ${booking.telephoneNumber} ${t("timebestilling.som-bekrefter-timen")}`
              }
            </SVVBodyText>
          </div>
        </>
      )}
      {!booking.bookingNumber && (
        <>
          <p className="spacing-bottom--medium">
            {t("timebestilling.du-mangler-refnr")}
          </p>
          <SVVButtonRow isFormRow>
            <SVVButtonCustom
              asElement={Link}
              href="/bestill/bekrefte"
              hrefAttribute="to"
              color="secondary"
            >
              {t("timebestilling.tilbake")}
            </SVVButtonCustom>
            <SVVButtonCustom
              asElement={Link}
              href="/"
              hrefAttribute="/"
              color="secondary"
            >
              {t("timebestilling.avbryt")}
            </SVVButtonCustom>
          </SVVButtonRow>
        </>
      )}
      {booking.bookingNumber &&
          <div className="svv-knapperad">
            <SVVButton 
              onClick={() => {window.location.href = getVegvesenBaseUrl()}}
              color="secondary"
            >
              {t("timebestilling.gå-tilbake-til-hovedsiden")}
            </SVVButton>
          </div>
      }
    </>
  );
};

export default Receipt;
